import { ref, computed } from 'vue';
import { Capacitor } from '@capacitor/core';

const platform = ref(Capacitor.getPlatform());
const isMobile = computed(() => platform.value === 'ios' || platform.value === 'android');

export function useCapacitorPlatform() {
  return {
    isMobile,
    platform,
  };
}